import { DynamicContent, GenericValue } from 'hisng';
import {
    EmploymentPayGrade, WorkingTime,
    Employee, EmploymentOrganization,
    PersonnelFinancing
} from 'app/fs/res/employment/model/employment-classes';

export class Employment extends DynamicContent {
    id: number;

    employmentPayGrades: EmploymentPayGrade[];  // besoldung/vergütung
    graduationType: GenericValue;
    workingTimes: WorkingTime[]; // VLA
    employee: Employee;
    employmentType: GenericValue;  // Personalkategorie / Bezeichnung
    activityType: GenericValue; // Tätigkeitsart

    orgunits: EmploymentOrganization[] = [];

    // to many relations #########################
    subjectAreas: GenericValue[];
    researchAreas: GenericValue[];
    researchAreasKdsf: GenericValue[];

    // Finanzierungsform
    personnelFinancings: PersonnelFinancing[]; // => financingType: GenericValue;

    validFrom: string | Date; // => startDate
    validTo: string | Date; // => endDate

    // for intern only ##########################
    lockVersion: number;

    // explicit internal employment to check of external organisation validation
    jointAppointment: boolean;

    // explicit internal employment with parent employment type
    parentType: GenericValue;
}
